module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pay-result"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "encircle"
  }, [_c('h1', [_vm._v("支付状态")]), _vm._v(" "), _c('div', {
    staticClass: "deliver"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "700px"
    }
  }, _vm._l((_vm.paramObj.orderNo), function(orderSn) {
    return _c('div', [_c('div', {
      staticClass: "order-list",
      staticStyle: {
        "float": "left"
      },
      on: {
        "click": function($event) {
          return _vm.toOrderDetail(orderSn)
        }
      }
    }, [_vm._v("点此查看订单" + _vm._s(orderSn))])])
  }), 0)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cart-nav"
  }, [_c('img', {
    attrs: {
      "src": "//static.kxymall.com/images/pay.jpg",
      "alt": "购物车及购物车进程"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "width": "100px"
    }
  }, [_c('img', {
    attrs: {
      "src": "//static.kxymall.com/images/jstj.jpg",
      "alt": "支付成功"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-375be53c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/shopping-cart/payResult.vue
// module id = 1572
// module chunks = 1